import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-slate-200 bg-slate-50 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1annvnx70wf35">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1amcrvxdkv7c1">The {totalBonuses} <span className="text-teal-700" data-id="element-21" data-mp="15q5ke05j9nrz">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-22" data-mp="1jgit44q916id">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-slate-200 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="r0gddoarepjs" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" data-id="element-24" data-mp="2jhmminjwzp7m">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ogg0eh345i8b" />
                </span>
                <div className="flex-1" data-id="element-26" data-mp="1qua7cyg32joc">
                  <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1" data-id="element-27" data-mp="1qvldh4x043im">
                    <p className="text-sm font-semibold text-amber-700" data-id="element-28" data-mp="1vuej6b61qq88">Bonus {bonus.number}</p>
                    <p className="text-sm font-semibold" data-id="element-29" data-mp="20thntui46ufo">
                      <span className="text-slate-400 line-through decoration-2" data-id="element-30" data-mp="25rj304cf69lv">{bonusValue}</span>{' '}
                      <span className="text-teal-700" data-id="element-31" data-mp="3c5s636z8f85v">FREE</span>
                    </p>
                  </div>
                  <h3 className="mt-1 text-lg font-semibold leading-snug text-slate-900" data-id="element-32" data-mp="3h43i9od01ur9">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600" data-id="element-33" data-mp="1h1kf649q34ye">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-xl border border-slate-200 bg-white px-6 py-6 text-center shadow-sm sm:flex-row sm:text-left" data-id="element-34" data-mp="1q322o7pgm8x4">
          <div data-id="element-35" data-mp="yce515mzvlo7">
            <p className="text-sm font-medium text-slate-500" data-id="element-36" data-mp="ydyxmppr0ujf">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-slate-400 line-through decoration-2" data-id="element-37" data-mp="tevrt31y2kae">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-38" data-mp="12er63gqsqven">
            <p className="text-sm font-medium text-slate-500" data-id="element-39" data-mp="12cy1e6zqul9a">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-teal-700" data-id="element-40" data-mp="envae8j7zg24">
              <GiftIcon className="h-7 w-7 text-amber-600" aria-hidden="true" data-id="element-41" data-mp="amjp2f7dpgzq" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}